import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import {
  HorariosClubesDispatcher,
  horariosClubesDispatcher
} from "./horariosClubesContainer.dispatcher";
import {
  HorariosClubesStore,
  horariosClubesStore
} from "./horariosClubesContainer.store";
import HorariosClubesComponent from "../../components/horariosCubesComponent/index";

interface Props extends HorariosClubesStore, HorariosClubesDispatcher {}

interface State {}

@ReduxConnect(horariosClubesStore, horariosClubesDispatcher)
export default class HorariosClubesContainer extends React.Component<
  Props,
  State
> {
  componentDidMount() {
    this.props.getConfiguracionesHorariosClubes();
    this.props.getMantenimientos();
    this.props.getClubes();
  }

  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Horarios Clubes" />
          <HorariosClubesComponent
            configuraciones={this.props.configuraciones}
            mantenimientos={this.props.mantenimientos}
            clubes={this.props.clubes}
            getConfiguracionesHorariosClubes={
              this.props.getConfiguracionesHorariosClubes
            }
            crearConfiguracionesHorariosClubes={
              this.props.crearConfiguracionesHorariosClubes
            }
            actualizarConfiguracionesHorariosClubes={
              this.props.actualizarConfiguracionesHorariosClubes
            }
            eliminarConfiguracionesHorariosClubes={
              this.props.eliminarConfiguracionesHorariosClubes
            }
            loadingStates={{
              searching: this.props.searching,
              saving: this.props.saving,
              updating: this.props.updating,
              deleting: this.props.deleting
            }}
          />
        </Layout>
      </main>
    );
  }
}
